module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Back-847005a27053fec9654b867cf5c3021e.svg";